// frontend-react/src/components/Home/CategoryNav.js
import React from 'react';
import { Box, Chip, Container } from '@mui/material';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';

const ScrollContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  overflowX: 'auto',
  gap: theme.spacing(1.5),
  padding: theme.spacing(2, 0),
  scrollBehavior: 'smooth',
  '&::-webkit-scrollbar': {
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    background: theme.palette.mode === 'dark' ? '#1a1a1a' : '#f1f1f1',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: theme.palette.primary.main,
    borderRadius: '10px',
    '&:hover': {
      background: theme.palette.primary.dark,
    },
  },
}));

const CategoryChipStyled = styled(Chip)(({ theme, categorycolor }) => ({
  fontWeight: 600,
  fontSize: '0.9rem',
  padding: theme.spacing(2, 1),
  backgroundColor: categorycolor || theme.palette.primary.main,
  color: '#fff',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    backgroundColor: categorycolor || theme.palette.primary.dark,
  },
}));

const CategoryNav = ({ categories }) => {
  if (!categories || categories.length === 0) return null;

  return (
    <Box sx={{ 
      bgcolor: 'background.paper', 
      borderBottom: '1px solid',
      borderColor: 'divider',
      py: 1
    }}>
      <Container maxWidth="xl">
        <ScrollContainer>
          <CategoryChipStyled
            label="📰 Todas"
            component={Link}
            to="/"
            clickable
            categorycolor="#667eea"
          />
          {categories.map((category) => (
            <CategoryChipStyled
              key={category.slug}
              label={category.name}
              component={Link}
              to={`/category/${category.slug}`}
              clickable
              categorycolor={category.color}
            />
          ))}
        </ScrollContainer>
      </Container>
    </Box>
  );
};

export default CategoryNav;
